<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import ProviderServices from '@/services/api/provider.api'
import DocumentServices from '@/modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Cumplimiento de Prestación de Servicios Relacionados',
      routes: [
        'Informes',
        'Informe de Cumplimiento de Prestación de Servicios Relacionados',
      ],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          months: [],
          monitoringTypes: [
            {
              id: 'Center',
              name: 'Centro',
            },
            {
              id: 'Provider',
              name: 'Proveedor',
            },
          ],
          referralTypes: [
            {
              id: 1,
              name: 'Inicial',
            },
            {
              id: 14,
              name: 'Continuidad',
            },
          ],
          centers: [],
          providers: [],
          locationTypes: [],
          locations: [],
        },
        filters: {
          academicYear: null,
          month: null,
          monitoringType: null,
          referralType: null,
          center: null,
          provider: null,
          locationType: null,
          location: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      let filters = [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          class: 'col-md-3',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onAcademicYearChange,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mes',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un mes.',
          validations: 'required',
          options: this.model.search.collections.months,
          value: this.model.search.filters.month,
        },
        {
          name: 'monitoringType',
          component: 'custom-drop-down',
          class: 'col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Monitoria a',
          validations: '',
          options: this.model.search.collections.monitoringTypes,
          value: this.model.search.filters.monitoringType,
          onChanged: this.onMonitoringTypeChange,
        },
        {
          name: 'referralType',
          component: 'custom-drop-down',
          class: 'col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Referido',
          placeholder: 'Seleccionar',
          validations: '',
          options: this.model.search.collections.referralTypes,
          value: this.model.search.filters.referralType,
        },
      ]

      let extraFilters =
        this.model.search.filters.monitoringType?.id == 'Center'
          ? this.getCenterFilters()
          : this.getProviderFilters()

      filters = filters.concat(extraFilters)

      return filters
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )

      await LocationServices.getAllCenters().then(
        (res) => (this.model.search.collections.centers = res.data)
      )

      this.model.search.filters.monitoringType = this.model.search.collections.monitoringTypes.find(
        (m) => m.id === 'Center'
      )
    },
    async onAcademicYearChange() {
      await AcademicYearServices.getMonthsInAcademicYear(
        this.model.search.filters.academicYear?.id
      ).then((res) => (this.model.search.collections.months = res.data))

      this.tryLoadProviderLocations()
    },
    async onMonitoringTypeChange() {
      if (this.model.search.filters.monitoringType.id === 'Provider') {
        ProviderServices.getAllProvidertCompaniesByYear(
          { AcademicYearId: this.model.search.filters.academicYear?.id }
        ).then((res) => (this.model.search.collections.providers = res.data))

        LocationServices.getLocationTypes().then(
          (res) => (this.model.search.collections.locationTypes = res.data)
        )
      }
    },
    async onLocationTypeChanged() {
      this.tryLoadProviderLocations()
    },
    async onProviderChanged() {
      this.tryLoadProviderLocations()
    },
    async tryLoadProviderLocations() {
      if (
        this.model.search.filters.monitoringType.id === 'Provider' &&
        this.model.search.filters.academicYear &&
        this.model.search.filters.provider &&
        this.model.search.filters.locationType
      ) {
        await LocationServices.getProviderLocations(
          this.model.search.filters.academicYear?.id,
          this.model.search.filters.provider?.id,
          this.model.search.filters.locationType?.id
        ).then((res) => (this.model.search.collections.locations = res.data))
      }
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (isValid) {
        this.process()
      }
    },
    async process() {
      if (
        this.model.search.filters.academicYear &&
        this.model.search.filters.month
      ) {
        await ReportServices.getReport('relatedservicemonitoring', {
          academicYearId: this.model.search.filters.academicYear.id,
          companyId: this.model.search.filters.provider?.id,
          reasonId: this.model.search.filters.reason?.id,
          statusId: this.model.search.filters.status?.id,
          centerId: this.model.search.filters.center?.id,
          monthNumber: this.model.search.filters.month?.id,
          monitoringType: this.model.search.filters.monitoringType?.id,
          referralType: this.model.search.filters.referralType?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
    getCenterFilters() {
      return [
        {
          name: 'center',
          component: 'custom-drop-down',
          class: 'col-md-3',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Centro',
          placeholder: 'Seleccionar',
          validations: '',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
        },
      ]
    },
    getProviderFilters() {
      return [
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          validations: '',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          onChanged: this.onProviderChanged,
        },
        {
          name: 'locationType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Lugar',
          placeholder: 'Seleccionar',
          validations: '',
          options: this.model.search.collections.locationTypes,
          value: this.model.search.filters.locationType,
          onChanged: this.onLocationTypeChanged,
        },
        {
          name: 'locations',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Lugar de Servicio',
          placeholder: 'Seleccionar',
          validations: '',
          options: this.model.search.collections.locations,
          value: this.model.search.filters.location,
        },
      ]
    },
  },
}
</script>
